import { render } from "./popularCarousel.vue?vue&type=template&id=79836050"
import script from "./popularCarousel.vue?vue&type=script&lang=js"
export * from "./popularCarousel.vue?vue&type=script&lang=js"

import "./popularCarousel.vue?vue&type=style&index=0&id=79836050&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__